import Repo from './Repo.js'
import SectorRepository from './SectorRepository';

export default class UserRepository extends Repo {
  constructor () {
    super('users')
  }

  me(data){
    return this.http.get(this.resource + '/me', data).then((response) => {
      return Promise.resolve(response);
    }).catch((response) =>{
      return Promise.reject(response);
    });
  }

  updateMe(data){
    return this.http.post(this.resource + '/me', data).then((response) => {
      return Promise.resolve(response);
    }).catch((response) =>{
      return Promise.reject(response);
    });
  }

  all (q, include) {
    return super.all(q, {include: include})
  }

  store (data) {
    return super.store(data)
  }

  upload(data){
    return this.http.post(this.resource + '/upload', data).then((response) => {
      return Promise.resolve(response);
    }).catch((response) =>{
      return Promise.reject(response);
    });
  }

  update (id, data) {
    return this.http.post(this.resource + '/' + id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q, include) {
    return super.paginate(q, include)
  }

  revisedSectors(include){
    return this.http.get(this.resource + '/revised-sectors', include).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchBySector (data, include) {
    if(include){
      data.include = include;
    }
    return this.http.post(this.resource + '/search/sectors/paginate', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
   }

  searchBySectorAndDownload (data, name = "Remaining Vacations") {
    return this.http.download(this.resource + "/search/sectors/download", data).then((response) => {
      let blob = new Blob([response.data], { type:   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.xlsx';
      link.click();
      return Promise.resolve(response);
    }).catch((response) =>{
      return Promise.reject(response);
    });
  }

  attachSector(id, sector_id, data){
    return this.http.post(this.resource + '/' + id + '/sectors/' + sector_id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
}

  detachSector(id, sector_id){
    return this.http.delete(this.resource + '/' + id + '/sectors/' + sector_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
   }

  attachRevisedSector(id, sector_id, data){
    return this.http.post(this.resource + '/' + id + '/revised-sectors/' + sector_id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachRevisedSector(id, sector_id){
    return this.http.delete(this.resource + '/' + id + '/revised-sectors/' + sector_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  myVacationRequests(data){
    return this.http.get(this.resource  + '/vacation-requests', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  myPaginatedVacationRequests(data){
    return this.http.get(this.resource  + '/vacation-requests/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  paginatedVacationRequests(id, data){
    return this.http.get(this.resource + '/' + id + '/vacation-requests/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  paginatedScheduledOvertimes(id, data){
    return this.http.get(this.resource + '/' + id + '/scheduled-overtimes/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  myPaginatedScheduledOvertimes(data){
    return this.http.get(this.resource + '/scheduled-overtimes/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  paginatedTravelWarrants(id, data){
    return this.http.get(this.resource + '/' + id + '/travel-warrants/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  myPaginatedTravelWarrants(data){
    return this.http.get(this.resource + '/travel-warrants/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  calcOvertimeForPeriod(data){
    return this.http.post(this.resource + '/scheduled-overtimes/calc', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachScheduledOvertime(id, overtime_id, data){
    return this.http.post(this.resource + '/' + id + '/scheduled-overtime/' + overtime_id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachScheduledOvertime(id, overtime_id){
    return this.http.delete(this.resource + '/' + id + '/scheduled-overtime/' + overtime_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
  
  attachProductSize(id, product_size_id){
    return this.http.post(this.resource + '/' + id + '/product-sizes/' + product_size_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachProductSize(id, product_size_id){
    return this.http.delete(this.resource + '/' + id + '/product-sizes/' + product_size_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachWorkplaceProductRulesUser(user_id, workplace_product_rules_id, data){
    return this.http.post(this.resource + '/' + user_id + '/workplace-product-rules/' + workplace_product_rules_id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachWorkplaceProductRulesUser(id, workplace_product_rules_id){
    return this.http.delete(this.resource + '/' + id + '/workplace-product-rules/' + workplace_product_rules_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachWorkplaceGroupationRulesUser(user_id, workplace_groupation_rules_id, data){
    return this.http.post(this.resource + '/' + user_id + '/workplace-groupation-rules/' + workplace_groupation_rules_id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachWorkplaceGroupationRulesUser(id, workplace_groupation_rules_id){
    return this.http.delete(this.resource + '/' + id + '/workplace-groupation-rules/' + workplace_groupation_rules_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getMySectors(include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource +  '/sectors/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getSectors(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/sectors/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getRevisedSectors(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/revised-sectors/paginated', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getProductSizes(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/product-sizes', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getMyUserCheckoutForms(data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    return this.http.get(this.resource + '/user-checkout-forms', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchByActiveUserCheckoutForms(data) {
    return this.http.get(this.resource + '/user-checkout-forms/search', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchByActiveUserCheckoutFormsAndExport(data, name = "User checkout forms states") {
    data.export = 1;
    return this.http.download(this.resource + '/user-checkout-forms/search', data).then((response) => {
      let blob = new Blob([response.data], { type:   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.xlsx';
      link.click();
      return Promise.resolve(response);
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchByUserByActiveUserCheckoutForms(id, data) {
    return this.http.get(this.resource + '/' + id + '/user-checkout-forms', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchByUserByActiveUserCheckoutFormsAndExport(id, data, name = "Equipment return") {
    return this.http.download(this.resource + '/' + id + '/user-checkout-forms', data).then((response) => {
      let blob = new Blob([response.data], { type:   'application/pdf' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.pdf';
      link.click();
      return Promise.resolve(response);
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  returnAllEquipment(user_id){
    return this.http.get(this.resource + '/' + user_id + '/return-all-equipment').then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getPotectiveGear() {
    return;
  }

  attachProtectiveGear() {
    return;
  }

  detachProtectiveGear() {
    return;
  }
  
}
